import { Dispatch, SetStateAction } from 'react'

import { ShotlistsService } from '@/services/shotlist.service'

import { PLATFORMS_CODES } from '@/constants/languages'
import { ILanguage } from '@/types/task.interface'
import { ISelectedPlatform, TPlatformValue } from '@/types/uploadForm.interface'

export const uploadSrt = async (
	taskId: string,
	file: File,
	languages: ILanguage[],
	selectedPlatform: TPlatformValue,
	setSelectedPlatformList: Dispatch<SetStateAction<ISelectedPlatform[]>>
) => {
	const language = languages.find(
		lang => lang.code === PLATFORMS_CODES[selectedPlatform]
	)?.code

	if (!taskId || !file || !selectedPlatform || !language) return

	const res = await ShotlistsService.uploadSrtFile(
		taskId,
		file,
		language,
		file.name
	)

	const shotlist = await ShotlistsService.getShotlist(taskId)

	const languagesArray = [shotlist.original, ...shotlist.translations].filter(
		Boolean
	)

	// if we do not have original language yet, we call changeOriginalLanguage. We need to do it only once!
	if (res.success && languagesArray.length === 1) {
		await ShotlistsService.changeOriginalLanguage(taskId, language)
	}

	// After adding srt-file we should refresh current selectedPlatform data
	setSelectedPlatformList(prev =>
		prev.map(p =>
			p.value === selectedPlatform
				? { ...p, headerState: 'done', result: 'transcription' }
				: p
		)
	)
}
